export interface ClippingParameterModel {
    id: number,
    clipperId: number,
    description: string,
    active: boolean,
    userId: number | null
}

export const clippingParameterModelInitial: ClippingParameterModel = {
    id: 0,
    clipperId: 0,
    description: '',
    active: false,
    userId: null
};